module.exports = __webpack_public_path__ + "img/anli-2.80bdf6f7.png";